import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const isMetaMaskConnectionOverlayError = (value) => {
  const text = String(
    value?.reason?.message ||
    value?.error?.message ||
    value?.message ||
    value ||
    ''
  );

  return text.includes('Failed to connect to MetaMask');
};

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (isMetaMaskConnectionOverlayError(event)) {
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    const fromMetaMaskExtension = String(event?.filename || '').includes('chrome-extension://');
    if (fromMetaMaskExtension && isMetaMaskConnectionOverlayError(event)) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode disabilitato temporaneamente per evitare doppi mount che causano troppe chiamate API
  <App />
);
